<template>
<div id="app">
	<router-view/>
</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	text-align: center;
	margin-top: 1em;
	font-size: 91%;
	line-height: 130%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue